module.exports = __webpack_public_path__ + "static/assets/a9dc204500d43ccc37afa879db7eb27f.png";